import { render, staticRenderFns } from "./AppSocial.vue?vue&type=template&id=81720ed4&scoped=true&"
import script from "./AppSocial.vue?vue&type=script&lang=js&"
export * from "./AppSocial.vue?vue&type=script&lang=js&"
import style0 from "./AppSocial.vue?vue&type=style&index=0&id=81720ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81720ed4",
  null
  
)

export default component.exports